import React from 'react';
import { createComponent } from '@lit/react';
import { IxMenuItem as LitComp } from '../IxMenuItem.js';

customElements.define('ix-menu-item', LitComp);

export const IxMenuItem = createComponent({
  tagName: 'ix-menu-item-react',
  elementClass: LitComp,
  react: React,
});
